export default __webpack_public_path__ + "static/media/client44.205982db.png";